import { render, staticRenderFns } from "./Ball.vue?vue&type=template&id=71b2f6a5&scoped=true&"
import script from "./Ball.vue?vue&type=script&lang=js&"
export * from "./Ball.vue?vue&type=script&lang=js&"
import style0 from "./Ball.vue?vue&type=style&index=0&id=71b2f6a5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b2f6a5",
  null
  
)

export default component.exports